import React, { useState, useEffect } from "react";
import { FaDownload, FaEdit, FaExpand, FaCopy } from "react-icons/fa";
import { lowQualityToHighQuality } from "../../config/aws";
import { listFoldersFromS3 } from "../../config/aws";
import { USER_NAME } from "../../constant";
const History = ({
  All_History,
  setSelectedGroup,
  setModalImage,
  setEditUploadedImages,
  setActiveTab,
  activeIndex,
  setActiveIndex,
  createPageNumber,
  setCreatePageNumber,
  containerRef,
  allEditHistory,
  setAllEditHistory,
  
  activeTab
}) => {
  const [selectedSize, setSelectedSize] = useState("preview");
  const [selectedFormat, setSelectedFormat] = useState("JPG");
  const [copiedPrompt, setCopiedPrompt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);

  const s3_sub_folder = activeTab === 'bgh' ? "all_bghPage" : "all_createPage";
  useEffect(() => {
    const fetchTotalPages = async () => {
      const folders = await listFoldersFromS3(`USERS/${USER_NAME}/${s3_sub_folder}/`);
      setTotalPages(Math.ceil(folders.length / 10));
    };

    fetchTotalPages();
  }, []);

  useEffect(() => {
    // Set a timeout to change loading state after 10 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleDownload = (image) => {
    if (!image) return;

    // Create a temporary link element
    const link = document.createElement('a');

    // Get the image URL based on selected size
    const imageUrl = selectedSize === "preview"
      ? image.src.replace(/\d+x\d+/, "512x512")
      : image.src.replace(/\d+x\d+/, "2048x2048");

    // Set the download attributes
    link.href = imageUrl;
    link.download = `image-${selectedSize}.${selectedFormat.toLowerCase()}`;

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const copyPromptToClipboard = (prompt, index) => {
    navigator.clipboard.writeText(prompt)
      .then(() => {
        setCopiedPrompt(index);
        setTimeout(() => setCopiedPrompt(null), 2000);
      })
      .catch(err => {
        console.error('Failed to copy prompt: ', err);
      });
  };

  const handleSelectFromHistory = async (entry) => {
    try {
      setSelectedGroup(entry.images);
      // Scroll container to top
      if (containerRef && containerRef.current) {
        containerRef.current.scrollTop = 0;
      }
    } catch (error) {
      console.error("Error processing images:", error);
    }
  };

  // const handleHistorySelect = async (entry) => {
  //   const promises = entry.images.map(async (image) => ({
  //     ...image,
  //     src: await lowQualityToHighQuality(image.src)
  //   }));
  //   const updatedImages = await Promise.all(promises);
  //   setSelectedGroup(updatedImages);
  // }

  return (
    <footer className="bg-gradient-to-r from-gray-50 to-white p-8 border-t border-gray-200 shadow-inner">
      <div className="max-w-7xl mx-auto">
        {All_History.length > 0 && (
          <h2 className="text-3xl font-bold text-gray-800 mb-8">History</h2>
        )}
        <div className="space-y-8">
          {All_History.map((entry, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300" onClick={() => handleSelectFromHistory(entry)}>
              <div className="grid grid-cols-6 gap-4 mb-6">
                <div className="flex flex-col space-y-1">
                  <span className="text-gray-500 text-sm">Product</span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-2 rounded-lg text-sm font-semibold">{entry.productName || "none"}</span>
                </div>
                <div className="flex flex-col space-y-1">
                  <span className="text-gray-500 text-sm">Style</span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-2 rounded-lg text-sm font-semibold">{entry.style || "none"}</span>
                </div>
                <div className="flex flex-col space-y-1">
                  <span className="text-gray-500 text-sm">Creative Control</span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-2 rounded-lg text-sm font-semibold">{entry.creativeControlValue==0 ? "Mode 1" : "Mode 2"}</span>
                </div>
                <div className="flex flex-col space-y-1">
                  <span className="text-gray-500 text-sm">Time</span>
                  <span className="bg-gray-200 text-gray-700 px-2 py-2 rounded-lg text-sm font-semibold">{entry.time || "none"}</span>
                </div>
                <div className="flex flex-col space-y-1 col-span-2 relative">
                  <span className="text-gray-500 text-sm">Prompt</span>
                  <div className="bg-gray-200 text-gray-700 px-2 py-2 rounded-lg text-sm font-semibold max-h-10 overflow-y-auto scrollbar-hide pr-10">
                    {entry.prompt || "none"}
                    <button
                      className="absolute right-2 top-7 bg-gray-300 hover:bg-gray-400 p-1.5 rounded-full transition-all duration-300 group"
                      onClick={(e) => {
                        e.stopPropagation();
                        copyPromptToClipboard(entry.prompt, index);
                      }}
                      aria-label="Copy prompt"
                    >
                      <FaCopy className="text-gray-600 text-sm group-hover:text-gray-800" />
                      <span className={`absolute -top-8 right-0 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-0 transition-opacity duration-300 whitespace-nowrap ${copiedPrompt === index ? 'opacity-100' : ''}`}>
                        {copiedPrompt === index ? 'Copied!' : 'Copy prompt'}
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {entry.images.map((image, imgIndex) => (
                  <div key={imgIndex} className="group relative aspect-square">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover rounded-xl shadow-md transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg"
                      style={{ aspectRatio: '1/1' }}
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 rounded-xl"></div>
                    <div className="absolute top-2 right-2 flex gap-1.5 z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {/* <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownload(image);
                        }}
                      >
                        <FaDownload className="text-gray-600 text-sm" />
                      </button> */}
                      <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={async (e) => {
                          e.stopPropagation();
                          // console.log("in Create History  click on send to canvas  fetching high quality images ");
                          const highQualityImage = await lowQualityToHighQuality(image.src);
                          setEditUploadedImages([{ src: highQualityImage, alt: "High Quality Image" }]);
                          setActiveTab('edit');
                          setAllEditHistory([{ images: [{ src: highQualityImage, alt: "Image from Create History" }] }, ...allEditHistory]);
                        }}
                      >
                        <FaEdit className="text-gray-600 text-sm" />
                      </button>
                      <button
                        className="bg-white/80 backdrop-blur-sm p-1.5 rounded-full shadow-md hover:bg-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                        onClick={async (e) => {
                          e.stopPropagation();
                          setModalImage({ src: await lowQualityToHighQuality(image.src), alt: "Image expanded" });
                        }}
                      >
                        <FaExpand className="text-gray-600 text-sm" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center items-center gap-4 mt-8">
        {/* <button
          className={`px-4 py-2 rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 ${isLoading
              ? 'bg-purple-500 text-white cursor-wait'
              : 'bg-purple-600 text-white shadow-md hover:bg-purple-700 hover:shadow-lg'
            }`}
          disabled={isLoading}
          onClick={() => {
            if (isLoading) return;
            setIsLoading(true);
            setTimeout(() => {
              setCreatePageNumber(createPageNumber + 1);
              setIsLoading(false);
            }, 10000);
          }}
        >
          {isLoading ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Loading...
            </>
          ) : (
            <>
              Load More
              <svg className="w-4 h-4 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
              </svg>
            </>
          )}
        </button> */}

        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              if (isLoading || createPageNumber === 0) return;
              setIsLoading(true);
              setTimeout(() => {
                setCreatePageNumber(createPageNumber - 1);
                setIsLoading(false);
              }, 1000);
            }}
            disabled={isLoading || createPageNumber === 0}
            className={`px-3 py-1 rounded-md transition-all duration-300 ${createPageNumber === 0
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
          >
            Previous
          </button>

          {Math.floor(createPageNumber / 10) > 0 && (
            <button
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  const prevPageSet = Math.max((Math.floor(createPageNumber / 10) - 1) * 10, 0);
                  setCreatePageNumber(prevPageSet);
                  setIsLoading(false);
                }, 1000);
              }}
              className="px-2 text-gray-500 hover:text-purple-600 transition-all duration-300"
              disabled={isLoading}
            >
              ...
            </button>
          )}

          {Array.from({ length: Math.min(10, totalPages) }, (_, i) => {
            // Calculate the starting page based on current page
            const startPage = Math.floor(createPageNumber / 10) * 10;
            return startPage + i;
          }).filter(pageNum => pageNum < totalPages).map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  setCreatePageNumber(pageNum);
                  setIsLoading(false);
                }, 1000);
              }}
              className={`px-3 py-1 rounded-md transition-all duration-300 ${createPageNumber === pageNum
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              disabled={isLoading}
            >
              {pageNum + 1}
            </button>
          ))}

          {totalPages > 10 && Math.floor(createPageNumber / 10) < Math.floor((totalPages - 1) / 10) && (
            <button
              onClick={() => {
                if (isLoading) return;
                setIsLoading(true);
                setTimeout(() => {
                  const nextPageSet = Math.min((Math.floor(createPageNumber / 10) + 1) * 10, totalPages - 1);
                  setCreatePageNumber(nextPageSet);
                  setIsLoading(false);
                }, 1000);
              }}
              className="px-2 text-gray-500 hover:text-purple-600 transition-all duration-300"
              disabled={isLoading}
            >
              ...
            </button>
          )}

          <button
            onClick={() => {
              if (isLoading || createPageNumber === totalPages - 1) return;
              setIsLoading(true);
              setTimeout(() => {
                setCreatePageNumber(createPageNumber + 1);
                setIsLoading(false);
              }, 1000);
            }}
            disabled={isLoading || createPageNumber === totalPages - 1}
            className={`px-3 py-1 rounded-md transition-all duration-300 ${createPageNumber === totalPages - 1
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
          >
            Next
          </button>
        </div>
      </div>
    </footer>
  );
};

export default History;
